var _rect, _g, _line, _g2, _line2, _g3, _g4, _g5, _g6, _text, _text2, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCeilingIdonotHeight01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 212,
    height: 232
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M187.2,229.5v-5.3h3.5v0.6h-2.8v1.7h2.8v0.6h-2.8v2.4H187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M191.5,229.5v-5.3h0.7v4.7h2.5v0.6H191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M195.6,228.3c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.4-0.4 c0.5,0,1,0.1,1.4,0.4s0.7,0.6,0.9,1s0.3,0.9,0.3,1.4s-0.1,1-0.3,1.4s-0.5,0.7-0.9,1s-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 S195.8,228.7,195.6,228.3z M196,226.9c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,1,0.3s0.7-0.1,1-0.3 s0.5-0.4,0.7-0.8s0.2-0.7,0.2-1.1c0-0.6-0.2-1.1-0.5-1.6s-0.8-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6 C196.2,225.7,196,226.2,196,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M201.7,228.3c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.4-0.4 c0.5,0,1,0.1,1.4,0.4s0.7,0.6,0.9,1s0.3,0.9,0.3,1.4s-0.1,1-0.3,1.4s-0.5,0.7-0.9,1s-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 S202,228.7,201.7,228.3z M202.1,226.9c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,1,0.3s0.7-0.1,1-0.3 s0.5-0.4,0.7-0.8s0.2-0.7,0.2-1.1c0-0.6-0.2-1.1-0.5-1.6s-0.8-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6 C202.3,225.7,202.1,226.2,202.1,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M207.8,229.5v-5.3h2.1c0.5,0,0.9,0.1,1.2,0.4s0.5,0.7,0.5,1.2c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1l1.4,2.2h-0.8l-1.4-2.1h-1.1v2.1H207.8z  M208.4,226.8h1.4c0.3,0,0.6-0.1,0.8-0.3s0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7s-0.5-0.3-0.8-0.3h-1.4V226.8z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.0384,
    x1: 0,
    y1: 227.3,
    x2: 183,
    y2: 227.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.0384,
    x1: 0,
    y1: 14,
    x2: 181.5,
    y2: 14
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M183.5,15.1c-0.1-0.3-0.2-0.7-0.2-1.1s0.1-0.8,0.2-1.1s0.3-0.6,0.6-0.9s0.5-0.4,0.9-0.6 c0.3-0.1,0.7-0.2,1.1-0.2c0.9,0,1.5,0.4,2,1.1l-0.6,0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.1-0.5-0.2-0.8-0.2c-0.6,0-1.1,0.2-1.5,0.6 S184,13.4,184,14c0,0.4,0.1,0.8,0.3,1.1s0.4,0.6,0.7,0.8s0.7,0.3,1,0.3c0.3,0,0.6-0.1,0.8-0.2c0.3-0.1,0.5-0.3,0.6-0.6l0.6,0.3 c-0.5,0.7-1.2,1.1-2,1.1c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.1-0.6-0.3-0.9-0.6S183.7,15.5,183.5,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M188.9,16.7v-5.3h3.5v0.6h-2.8v1.7h2.8v0.6h-2.8v1.8h2.8v0.6H188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M193.5,16.7v-5.3h0.7v5.3H193.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M195.3,16.7v-5.3h0.7v4.7h2.5v0.6H195.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M199.4,16.7v-5.3h0.7v5.3H199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M201.3,16.7v-5.3h0.7l3.1,4.2v-4.2h0.7v5.3H205l-3.1-4.3v4.3H201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M206.9,15.1c-0.1-0.3-0.2-0.7-0.2-1.1s0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.9s0.5-0.4,0.9-0.6 s0.7-0.2,1.1-0.2c0.8,0,1.5,0.3,2.1,1l-0.5,0.3c-0.2-0.2-0.4-0.4-0.7-0.5c-0.3-0.1-0.6-0.2-0.9-0.2c-0.6,0-1.1,0.2-1.5,0.6 c-0.4,0.4-0.6,0.9-0.6,1.6c0,0.4,0.1,0.8,0.3,1.1c0.2,0.3,0.4,0.6,0.7,0.8c0.3,0.2,0.7,0.3,1,0.3c0.3,0,0.6-0.1,0.8-0.2 c0.3-0.1,0.5-0.2,0.6-0.4v-1.1h-1.8v-0.6h2.5v1.9c-0.3,0.3-0.6,0.5-0.9,0.7s-0.8,0.2-1.2,0.2c-0.4,0-0.7-0.1-1.1-0.2 s-0.6-0.3-0.9-0.6S207.1,15.5,206.9,15.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2023,
    x1: 72,
    y1: 19.2,
    x2: 72,
    y2: 221.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "68.4,20.2 72,14 75.6,20.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "68.4,220.2 72,226.4 75.6,220.2  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2023,
    x1: 105.7,
    y1: 19.2,
    x2: 105.7,
    y2: 221.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "102.1,20.2 105.7,14 109.3,20.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "102.1,220.2 105.7,226.4 109.3,220.2  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2023,
    x1: 140,
    y1: 19.2,
    x2: 140,
    y2: 221.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "136.4,20.2 140,14 143.6,20.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "136.4,220.2 140,226.4 143.6,220.2  "
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 68.7126 7.3352)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 10
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 102.5222 7.335)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 10
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 137.1211 7.3352)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 10
  }, "C")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeilingIdonotHeight01);
export default __webpack_public_path__ + "static/media/Ceiling-IDONOT-Height-01.65429085ae63e2e947d88aa1b6387c7f.svg";
export { ForwardRef as ReactComponent };